module.exports = __webpack_public_path__ + "img/856acb2.png";